export const FLAG_BASE_FUEL_REFILL_ACTIVITY = 'FLAG_BASE_FUEL_REFILL_ACTIVITY';
export const GET_BASE_FUEL_REFILL = 'GET_BASE_FUEL_REFILL';
export const CLEAR_BASE_FUEL_REFILL = 'CLEAR_BASE_FUEL_REFILL';
export const FLAG_IS_CIRCUIT_EXTRAORDINARY = 'FLAG_IS_CIRCUIT_EXTRAORDINARY';
export const FLAG_GETTING_BASE_FUEL_REFILLS = 'FLAG_GETTING_BASE_FUEL_REFILLS';
export const GET_BASE_FUEL_REFILLS = 'GET_BASE_FUEL_REFILLS';
export const CLEAR_BASE_FUEL_REFILLS = 'CLEAR_BASE_FUEL_REFILLS';
